import type {AdLocation} from '@frontend/modules/public/ads/AdsModuleTypes'

// Поиск локации по ID (рекурсивный).
export function findLocationById(
    locations: AdLocation[],
    id: number | null
): null | AdLocation {
    if (id === null) {
        return null
    }
    for (const item of locations) {
        if (item.id === id) {
            return item
        } else if (item.children.length) {
            const location: AdLocation | null = findLocationById(
                item.children,
                id
            )
            if (location) {
                return location
            }
        }
    }
    return null
}
